var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13C17.9249 13 13 17.9249 13 24C13 30.0751 17.9249 35 24 35C30.0751 35 35 30.0751 35 24C35 17.9249 30.0751 13 24 13ZM25 17.5C25 16.9477 24.5523 16.5 24 16.5C23.4477 16.5 23 16.9477 23 17.5V18C21.067 18 19.5 19.567 19.5 21.5C19.5 23.433 21.067 25 23 25H25C25.8284 25 26.5 25.6716 26.5 26.5C26.5 27.3284 25.8284 28 25 28H22.8333C22.097 28 21.5 27.403 21.5 26.6667C21.5 26.1144 21.0523 25.6667 20.5 25.6667C19.9477 25.6667 19.5 26.1144 19.5 26.6667C19.5 28.5076 20.9924 30 22.8333 30H23V30.5C23 31.0523 23.4477 31.5 24 31.5C24.5523 31.5 25 31.0523 25 30.5V30C26.933 30 28.5 28.433 28.5 26.5C28.5 24.567 26.933 23 25 23H23C22.1716 23 21.5 22.3284 21.5 21.5C21.5 20.6716 22.1716 20 23 20H25.1667C25.903 20 26.5 20.597 26.5 21.3333C26.5 21.8856 26.9477 22.3333 27.5 22.3333C28.0523 22.3333 28.5 21.8856 28.5 21.3333C28.5 19.4924 27.0076 18 25.1667 18H25V17.5Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.ecbe488cb23f5b5cc7f0bf6332e33387.svg";
export { ForwardRef as ReactComponent };